import { render, staticRenderFns } from "./ShareStatistics.vue?vue&type=template&id=7938d988&scoped=true"
import script from "./ShareStatistics.vue?vue&type=script&lang=js"
export * from "./ShareStatistics.vue?vue&type=script&lang=js"
import style0 from "./ShareStatistics.vue?vue&type=style&index=0&id=7938d988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938d988",
  null
  
)

export default component.exports